var render, staticRenderFns
import script from "./VAutoNumeric.vue?vue&type=script&lang=js&"
export * from "./VAutoNumeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35099f50",
  null
  
)

export default component.exports